import { Injectable } from '@angular/core';
import { OAuthStorage } from 'angular-oauth2-oidc';

/**
 * No-op storage for the plugin/iframe contexts: tokens must never be
 * persisted there, and reads must always come back empty.
 */
@Injectable()
export class MemoryStorageMock extends OAuthStorage {
  getItem(key: string): string | null {
    return null;
  }

  removeItem(key: string): void {}

  setItem(key: string, data: string): void {}
}
